import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagCompraResponse } from '../../responses/compras/get-tag-compra.response';
import { CreateTagCompraResponse } from '../../responses/compras/create-tag-compra.response';
import { TagComprasRequest } from '../../requests/compras/tag-compra.request';
import { TagBulkDeleteRequest } from '../../requests/compras/tag-bulk-delete.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class TagCompraService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'TagCompra';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagCompraResponse> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (descricao) {
      params = params.set('descricao', descricao);
    }

    return this.httpClient
      .get<GetTagCompraResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getById(id: number): Observable<CreateTagCompraResponse> {
    const url = `${this.apiUrl}/idTagCompra/${id}`;
    return this.httpClient
      .get<CreateTagCompraResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public create(request: TagComprasRequest): Observable<CreateTagCompraResponse> {
    return this.httpClient
      .post<CreateTagCompraResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(id: number, request: TagComprasRequest): Observable<CreateTagCompraResponse> {
    const url = `${this.apiUrl}/idTagCompra/${id}`;
    return this.httpClient
      .put<CreateTagCompraResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public delete(id: number): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/idTagCompra/${id}`;
    return this.httpClient
      .delete<ReturnStruct>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteBulk(ids: number[]): Observable<ReturnStruct> {
    const request: TagBulkDeleteRequest = { ids };
    const url = `${this.apiUrl}/bulk-delete`;
    return this.httpClient
      .post<ReturnStruct>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
